export const DIETARY_OPTIONS = [
  { value: 'vegetarian', label: 'Vegetarian', emoji: '🥬' },
  { value: 'vegan', label: 'Vegan', emoji: '🌱' },
  // "Free-of" restrictions use a neutral 🚫 rather than the excluded ingredient
  // (🌾/🥛/🥜), which misleadingly read as "contains" next to a "-Free" label.
  { value: 'gluten-free', label: 'Gluten-Free', emoji: '🚫' },
  { value: 'dairy-free', label: 'Dairy-Free', emoji: '🚫' },
  { value: 'nut-free', label: 'Nut-Free', emoji: '🚫' },
  { value: 'keto', label: 'Keto', emoji: '🥑' },
  { value: 'whole30', label: 'Whole30', emoji: '🥩' },
  { value: 'atkins', label: 'Atkins', emoji: '🍖' },
  // Neutral "certification" glyph rather than religious symbols (☪️/✡️), which
  // read as glib as tiny decorative emoji. The text label carries the meaning.
  { value: 'halal', label: 'Halal', emoji: '🏷️' },
  { value: 'kosher', label: 'Kosher', emoji: '🏷️' },
];

/** Map of dietary tag value to its option object for quick lookup */
export const DIETARY_MAP = Object.fromEntries(
  DIETARY_OPTIONS.map(opt => [opt.value, opt])
);

/** Human label for a restriction value; falls back to the raw value (e.g. a
 *  custom allergy the family typed in). */
export function dietaryLabel(value) {
  return DIETARY_MAP[value]?.label || value;
}

/**
 * Returns recipes that satisfy ALL of a member's dietary restrictions.
 * A recipe must have every required tag in its `tags` array.
 */
export function filterByDietary(recipes, restrictions) {
  if (!restrictions?.length) return recipes;
  return recipes.filter(r =>
    restrictions.every(req => r.tags?.includes(req))
  );
}

/**
 * Returns the restrictions a recipe does NOT satisfy (a recipe satisfies a
 * restriction only when its `tags` include that value). Powers the soft
 * override: surface conflicts as warnings without blocking the pick.
 */
export function getDietaryConflicts(recipe, restrictions) {
  if (!restrictions?.length) return [];
  return restrictions.filter(req => !recipe?.tags?.includes(req));
}
